// V4.1.4: ArsivArama Component
import React, { useState, useEffect } from 'react';
import { formatTurkishCurrency } from '../utils/formatters';
import { styles } from '../constants/styles';

const ArsivArama = ({ kumbaralar, acilmisKumbaralar = [] }) => {
  const [arama, setArama] = useState('');
  const [sonuclar, setSonuclar] = useState([]);

  useEffect(() => {
    if (!arama.trim()) {
      setSonuclar([]);
      return;
    }

    const aramaID = arama.trim();
    const bulunanAktif = kumbaralar.filter(k => 
      k.arsiv && Array.isArray(k.arsiv) && k.arsiv.includes(aramaID)
    );
    const bulunanAcilmis = acilmisKumbaralar.filter(ak => 
      (ak.arsiv && Array.isArray(ak.arsiv) && ak.arsiv.includes(aramaID)) || 
      ak.id === aramaID || 
      (ak.orijinalId && ak.orijinalId === aramaID)
    );
    setSonuclar([...bulunanAktif.map(k => ({...k, tip: 'aktif'})), ...bulunanAcilmis.map(ak => ({...ak, tip: 'acilmis'}))]);
  }, [arama, kumbaralar, acilmisKumbaralar]);

  return (
    <div style={{background: '#f7fafc', padding: '15px', borderRadius: '10px', marginBottom: '20px'}}>
      <input
        type="text"
        placeholder="🔍 Arşiv ID'sine göre ara (örn: 001, 050)"
        value={arama}
        onChange={(e) => setArama(e.target.value)}
        style={{...styles.input, width: '100%', marginBottom: '15px'}}
      />
      {sonuclar.length > 0 && (
        <div>
          <div style={{fontSize: '14px', color: '#4a5568', marginBottom: '10px'}}>
            {sonuclar.length} sonuç bulundu
          </div>
          {sonuclar.map(k => (
            <div key={k.id || k.firestoreId} style={{padding: '12px', background: k.tip === 'acilmis' ? '#fff5f5' : 'white', borderRadius: '8px', marginBottom: '10px', border: `1px solid ${k.tip === 'acilmis' ? '#fc8181' : '#e2e8f0'}`}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '5px'}}>
                <span style={{fontWeight: 'bold'}}>📍 {k.firmaAdi || 'Firma yok'}</span>
                <span style={{...styles.badge, background: k.tip === 'acilmis' ? '#fc8181' : '#4299e1', color: 'white', fontSize: '11px'}}>
                  {k.tip === 'acilmis' ? 'Açılmış' : 'Aktif'}
                </span>
              </div>
              <div style={{fontSize: '12px', color: '#718096'}}>Mevcut ID: {k.id} | Arşiv: {k.arsiv ? k.arsiv.join(', ') : '-'}</div>
              <div style={{fontSize: '12px', color: '#718096'}}>Adres: {k.adres || 'Adres yok'}</div>
              {k.tip === 'acilmis' && k.tutar && (
                <div style={{fontSize: '12px', color: '#c53030', marginTop: '5px'}}>
                  💰 Açılma: {formatTurkishCurrency(k.tutar)} ₺
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {arama.trim() && sonuclar.length === 0 && (
        <p style={{color: '#718096', textAlign: 'center', padding: '20px'}}>❌ Arşiv ID bulunamadı</p>
      )}
    </div>
  );
};

export default ArsivArama;

